<template>
  <div>
    <b-modal
      id="bank-account-modal"
      size="lg"
      title="Financial Information"
      hide-footer
      centered
      body-class="modal-body-scrollable"
    >
      <div>
        <b-row>
          <b-col cols="12" class="border-right">
            <h5>Bank Accounts (Withdrawal)</h5>
            <div
              v-for="(acc, i) in bankAccounts"
              :key="i"
              class="d-flex border-bottom pb-1 text-black justify-content-between align-items-center"
            >
              <p class="font-weight-bold text-nowrap">
                Bank Acc {{ i + 1 }}:
                <span class="font-weight-normal">BSB {{ acc.bsb }}</span> •
                <span class="font-weight-normal">ACC {{ acc.number }}</span>
              </p>
              <div class="d-flex">
                <b-button size="sm" variant="outline-secondary" class="mr-1"
                  >Edit</b-button
                >
                <b-button size="sm" variant="outline-danger" class="text-danger"
                  >Delete</b-button
                >
              </div>
            </div>

            <b-button variant="primary" class="mt-1">+ Add Bank</b-button>

            <b-row class="mt-1">
              <b-col cols="6">
                <h5 class="mb-2">PayID</h5>
                <div
                  class="text-black border p-1 rounded d-flex justify-content-between"
                >
                  -
                  <div>
                    <b-button size="sm" variant="outline-secondary" class="mr-1"
                      >Edit</b-button
                    >
                    <b-button size="sm" variant="outline-danger"
                      >Delete</b-button
                    >
                  </div>
                </div>
              </b-col>

              <b-col cols="6" class="text-black">
                <h5>Stats & Actions</h5>
                <b-row>
                  <b-col cols="6" class="mb-1">
                    <div class="border rounded p-1 text-center">
                      <div class="text-muted">Withdrawal RG pending</div>
                      <div class="font-weight-bold">Yes</div>
                      <p class="text-primary">Review</p>
                    </div>
                  </b-col>

                  <b-col cols="6" class="mb-1">
                    <div class="border rounded p-1 text-center">
                      <div class="text-muted">Withdrawals to be processed</div>
                      <div class="font-weight-bold">3</div>
                      <p class="text-primary">View</p>
                    </div>
                  </b-col>

                  <b-col cols="6" class="mb-1">
                    <div class="border rounded p-1 text-center">
                      <div class="text-muted">Deposits Made total</div>
                      <div class="font-weight-bold">$12,345</div>
                      <p class="text-primary">Details</p>
                    </div>
                  </b-col>

                  <b-col cols="6" class="mb-1">
                    <div class="border rounded p-1 text-center">
                      <div class="text-muted">Bank accounts created</div>
                      <div class="font-weight-bold">3</div>
                      <p class="text-primary">View All</p>
                    </div>
                  </b-col>

                  <b-col cols="6" class="mb-1">
                    <div class="border rounded p-1 text-center">
                      <div class="text-muted">Debit cards created</div>
                      <div class="font-weight-bold">2</div>
                      <p class="text-primary">View All</p>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BContainer, BRow, BCol, BButton } from "bootstrap-vue";
import { arrayProp } from "@/helpers/props";
export default {
  props: {
    bankAccounts: arrayProp(),
  },
  components: {
    BModal,
    BContainer,
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
.modal-body-scrollable {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
